<template>
  <div class="authorize-field">
    <el-row
      type="flex"
      :gutter="20">
      <el-col :span="8">
        <div class="authorize-field__title" style="color: red;" v-if="isValid">
          {{text}}<b v-if="isRequired">*</b>:
        </div>
        <div class="authorize-field__title" v-if="!isValid">
          {{text}}<b v-if="isRequired">*</b>:
        </div>
      </el-col>
      <el-col :span="16">
        <input
          type="password"
          :value="field.value"
          :placeholder="placeholder"
          :class="isValid ? 'inputErrorValidate' : ''"
          @input="onInput">
      </el-col>
    </el-row>
  </div>
</template>

<script>
  import input from '../mixins/input'

  export default {
    name: 'Password',
    mixins: [input],
    props: {
      placeholder: {
        type: String,
        default: 'Пароль'
      }
    },
    methods: {
      onInput: function (e) {
        this.onChange(e.target.value)
      }
    }
  }
</script>
<style lang="scss" scoped>
.inputErrorValidate {
  border: 1px solid red;
}
</style>




// WEBPACK FOOTER //
// src/components/Auth/Inputs/Password.vue